import * as React from "react";
import { Modal, Spin } from "antd";

interface Props {
  showModal: boolean;
  onOkay?: () => void;
  toggleModal: () => void;
  inscription: string | JSX.Element;
  title?: string;
  okText?: string;
  showFooter?: boolean | undefined;
  width?: number;
  okType?:
  | "link"
  | "text"
  | "danger"
  | "default"
  | "primary"
  | "ghost"
  | "dashed"
  | undefined;
  isLoading?: boolean;
  okayButtonProps?: {
    disabled: boolean;
  };
  maskClosable?: boolean;
}

export default function ModalCreator(props: Props): JSX.Element {
  const showFooter =
    typeof props.showFooter === "undefined" ? true : props.showFooter;
  return (
    <div>
      {showFooter && (
        <Modal
          title={props.title || "Confirm Action"}
          visible={props.showModal}
          width={props.width || 520}
          maskClosable={props.maskClosable || false}
          {...{
            okText: props.okText || "Yes",
            okType: props.okType || "danger",
            cancelButtonProps: {
              className: "modal-cancel-btn",
            },
            okButtonProps: {
              className: "modal-confirm-btn",
              disabled: props.okayButtonProps?.disabled,
            },
          }}
          onOk={props.onOkay}
          onCancel={props.toggleModal}
        >
          <Spin spinning={props.isLoading || false}>
            <div>{props.inscription}</div>
          </Spin>
        </Modal>
      )}
      {!showFooter && (
        <Modal
          title={props.title || "Confirm Action"}
          visible={props.showModal}
          width={props.width || 520}
          maskClosable={props.maskClosable || false}
          {...{
            okText: props.okText || "Yes",
            okType: props.okType || "danger",
            cancelButtonProps: {
              className: "modal-cancel-btn",
            },
            okButtonProps: {
              className: "modal-confirm-btn",
              disabled: props.okayButtonProps?.disabled,
            },
          }}
          onOk={props.onOkay}
          onCancel={props.toggleModal}
          footer={null}
        >
          <Spin spinning={props.isLoading || false}>
            <div>{props.inscription}</div>
          </Spin>
        </Modal>
      )}
    </div>
  );
}
